import { ChangeEvent, useCallback, useEffect, useRef } from 'react';
import Autocomplete from 'react-google-autocomplete';

const SEARCH_TYPES = ['address'];
const COMPONENT_RESTRICTIONS = { country: 'nz' };

interface IAddressSearchProps {
  autoFocus?: boolean;
  autocomplete?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
  placeholder?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelect?: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

const AddressSearch = ({
  autocomplete,
  className,
  onChange,
  onSelect,
  disabled,
  value,
  placeholder,
  name,
  autoFocus,
}: IAddressSearchProps) => {
  const ref = useRef(null);

  useEffect(() => {
    let setTimeOutId;
    const inputRef = ref.current?.refs?.input;
    if (autoFocus && inputRef) {
      setTimeOutId = setTimeout(() => inputRef.focus(), 500);
    }

    return () => {
      if (setTimeOutId) {
        clearTimeout(setTimeOutId);
      }
    };
  }, [autoFocus]);

  const handlePlaceSelected = useCallback(
    ({ address_components, formatted_address, geometry }) => {
      const target = {
        name,
        value: formatted_address
          .replace('apartment ', '')
          .replace(/, New Zealand$/i, ''),
        addressComponents: address_components,
        lng: geometry?.location?.lng(),
        lat: geometry?.location?.lat(),
      };

      const evt = { target } as ChangeEvent<HTMLInputElement>;

      if (onSelect) {
        onSelect(evt);
      } else {
        onChange(evt);
      }
    },
    [name, onChange],
  );

  return (
    <Autocomplete
      ref={ref}
      id={name}
      className={className}
      name={name}
      onChange={onChange}
      onPlaceSelected={handlePlaceSelected}
      types={SEARCH_TYPES}
      componentRestrictions={COMPONENT_RESTRICTIONS}
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      inputAutocompleteValue={autocomplete}
    />
  );
};

export default AddressSearch;
